import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import GameContext from "../Context";
import GameRestartModal from "../RestartModal";
import GameLinks from "../Links";
import GameScoreFrame from "../ScoreFrame/ScoreFrame";
import GameCopyright from "../Copyright";
import play from "../Audio/Audio";

import "./Scoreboard.scss";

function GameScoreboard() {
  const { engine } = useContext(GameContext);

  const [showModal, setShowModal] = useState<boolean>(false);

  const history = useHistory();

  const onShowModal = () => {
    setShowModal(true);
  };

  const onHideModal = () => {
    setShowModal(false);
  };

  const onRestart = () => {
    history.push("/");
  };

  const onSubmit = () => {
    if (engine.hasAllGuesses()) {
      engine.submitGuesses();
    } else {
      const guessCount = engine.getGuessCount();
      const ballCount = engine.getBallCount();
      toast.warn(
        guessCount === 0
          ? `You haven't made any guesses!`
          : `You have only made ${guessCount} of ${ballCount} guesses.`
      );
      play("BONK");
    }
  };

  return (
    <>
      <div className="scoreboard">
        <GameLinks />

        <GameScoreFrame value={engine.getScore()} label="Running score" />

        <div className="button-bar">
          <button className="game-button" onClick={onSubmit}>
            Submit
          </button>
          <button className="game-button" onClick={onShowModal}>
            Restart
          </button>
        </div>

        <GameCopyright />
      </div>

      <GameRestartModal open={showModal} onClose={onHideModal} onYes={onRestart} />
    </>
  );
}

export default GameScoreboard;
